import type { ConceptContentData } from "../types";
import { ConceptCodeBlock, ConceptText } from "./components";

type MakefilesContent = Extract<ConceptContentData, { slug: "makefiles" }>;

// Introduce the input file itself before explaining how GNU Make finds it.
//
export function MakefilesConcept({ content }: { content: MakefilesContent }) {
  return (
    <div className="grid gap-8">
      <div
        className="grid scroll-mt-20 items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(20rem,1fr)]"
        id="what-is-a-makefile"
      >
        <div className="grid gap-4">
          {content.paragraphs.map((paragraph) => (
            <p key={paragraph} className="text-muted-foreground leading-7">
              <ConceptText text={paragraph} />
            </p>
          ))}
        </div>

        <ConceptCodeBlock
          caption={content.exampleCaption}
          lines={content.exampleLines}
        />
      </div>

      <div className="border-l-2 border-sky-500/60 bg-sky-50/70 px-4 py-3 dark:bg-sky-950/20">
        <p className="text-sm leading-6">
          <ConceptText text={content.distinction} />
        </p>
      </div>
    </div>
  );
}
